var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "message-order"
  }, [_c('div', {
    staticClass: "order-guide"
  }, [_vm._v(" " + _vm._s(_vm.props.payload.content.guide) + " ")]), _c('div', {
    staticClass: "order-main"
  }, [_vm.props.payload.content.pic ? _c('img', {
    staticClass: "order-img",
    attrs: {
      "src": _vm.props.payload.content.pic
    }
  }) : _vm._e(), _c('div', {
    staticClass: "order-information"
  }, [_c('div', {
    staticClass: "order-name"
  }, [_vm._v(" " + _vm._s(_vm.props.payload.content.name) + " ")]), _c('div', {
    staticClass: "order-description"
  }, [_vm._v(" " + _vm._s(_vm.props.payload.content.desc) + " ")])])]), _vm._l(_vm.props.payload.content.customField, function (item) {
    return _c('div', {
      staticClass: "order-custom"
    }, [_c('div', {
      staticClass: "order-field"
    }, [_c('span', {
      staticClass: "field-name"
    }, [_vm._v(" " + _vm._s(item.name) + " ")]), _c('span', {
      staticClass: "field-value"
    }, [_vm._v(" " + _vm._s(item.value) + " ")]), _c('span', {
      staticClass: "field-customer-value"
    }, [_vm._v(" " + _vm._s(item.customerValue) + " ")])])]);
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }